import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Journal from "./pages/Journal";
import Story from "./pages/Story";
import ClientGallery from "./pages/ClientGallery";

function App() {
  return (
    <BrowserRouter>
      <div className="bg-obsidian text-ivory min-h-screen font-sans antialiased">
        <div className="grain-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<Story />} />
          <Route path="/gallery/:slug" element={<ClientGallery />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
